declare global {
  interface Window { env: any; }
}

/**
 * Environment file compiled into the `production` build configuration — the
 * default for `ng build`, and what CI uses for release/* branches. Lower
 * environments (master, merge requests, `npm start`) compile
 * `environment.dev.ts` instead.
 */
export const environment = {
  production: true,
  backEndUrl: window.env['backendUrl'],
  issuer: window.env['issuer'],
  redirectUri: window.env['redirectUri'],
  clientId: window.env['clientId'],
  responseType: 'code',
  scope: 'openid profile email',
  showDebugInformation: true,
  portalSupportUrl: window.env['portalSupportUrl'],
  hucuIntegrationUrl: window.env['hucuIntegrationUrl'],
  hucuPublicKey: window.env['hucuPublicKey'],
  hucuIframeLoadingDelayMs: window.env['hucuIframeLoadingDelayMs'], // Default 2 seconds
  hucuNotificationFrequencyMinutes: window.env['hucuNotificationFrequencyMinutes'],
  featureFlags: {
    activeNotificationSidebar: true,
    enableGlobalPatientSearch: true,
    physicianPatientListManagement: false,
  },
  appInsights: {
    instrumentationKey: window.env['appInsights'],
    appName: window['env']['appInsightsAppName'] || 'Portal',
  },
  whiteListUrls: {
    metabase: window.env['metabaseSiteUrl']
  },
  version: window.env['version'],
  comingSoonDashboardWidgets: window.env['comingSoonDashboardWidgets'],
  // Pendo runs in every environment against the same subscription key (confirmed with
  // the Pendo provider), injected at container start from PENDO_API_KEY. The key is
  // tied to the content-<subscription-id>.static.pendo.io host allow-listed in the
  // Content-Security-Policy in config/localhost.conf — pointing an environment at a
  // different Pendo subscription means updating that header too.
  pendo: {
    enabled: true,
    apiKey: window.env['pendoApiKey'],
  }
}
